export default __webpack_public_path__ + "static/logo-c5b4e1a5fec5723dc320d03c4b2cf595.png";